// Generated by ReScript, PLEASE EDIT WITH CARE


function localeTypeToString(locale) {
  if (locale === undefined) {
    return "en";
  }
  switch (locale) {
    case "En" :
        return "en";
    case "He" :
        return "he";
    case "Fr" :
        return "fr";
    case "En_GB" :
        return "en-GB";
    case "Ar" :
        return "ar";
    case "Ja" :
        return "ja";
    case "De" :
        return "de";
    case "Fr_BE" :
        return "fr-BE";
    case "Es" :
        return "es";
    case "Ca" :
        return "ca";
    case "Pt" :
        return "pt";
    case "It" :
        return "it";
    case "Pl" :
        return "pl";
    case "Nl" :
        return "nl";
    case "NL_BE" :
        return "nl-BE";
    case "Sv" :
        return "sv";
    case "Ru" :
        return "ru";
    case "Lt" :
        return "lt";
    case "Cs" :
        return "cs";
    case "Sk" :
        return "sk";
    case "Is" :
        return "is";
    case "Cy" :
        return "cy";
    case "El" :
        return "el";
    case "Et" :
        return "et";
    case "Fi" :
        return "fi";
    case "Nb" :
        return "nb";
    case "Bs" :
        return "bs";
    case "Da" :
        return "da";
    case "Ms" :
        return "ms";
    case "Tr_CY" :
        return "tr-CY";
    case "Zh" :
        return "zh";
    case "ZhHant" :
        return "zh-Hant";
    
  }
}

function localeStringToType(locale) {
  switch (locale) {
    case "ar" :
        return "Ar";
    case "bs" :
    case "bs-BA" :
        return "Bs";
    case "ca" :
    case "ca-ES" :
        return "Ca";
    case "cs" :
    case "cs-CZ" :
        return "Cs";
    case "cy" :
    case "cy-GB" :
        return "Cy";
    case "da" :
    case "da-DK" :
        return "Da";
    case "de" :
    case "de-AT" :
    case "de-CH" :
    case "de-DE" :
    case "de-LI" :
        return "De";
    case "el" :
    case "el-CY" :
    case "el-GR" :
        return "El";
    case "en-GB" :
        return "En_GB";
    case "es" :
    case "es-419" :
    case "es-AR" :
    case "es-CL" :
    case "es-CO" :
    case "es-CR" :
    case "es-ES" :
    case "es-HN" :
    case "es-MX" :
    case "es-PE" :
    case "es-US" :
    case "es-UY" :
    case "es-VE" :
        return "Es";
    case "et" :
    case "et-EE" :
        return "Et";
    case "fi" :
    case "fi-FI" :
        return "Fi";
    case "fr-BE" :
        return "Fr_BE";
    case "fr" :
    case "fr-CA" :
    case "fr-CH" :
    case "fr-FR" :
        return "Fr";
    case "is" :
    case "is-IS" :
        return "Is";
    case "it" :
    case "it-CH" :
    case "it-IT" :
        return "It";
    case "he" :
    case "he-IL" :
    case "iw" :
        return "He";
    case "ja" :
    case "ja-JP" :
        return "Ja";
    case "lt" :
    case "lt-LT" :
        return "Lt";
    case "ms" :
    case "ms-MY" :
        return "Ms";
    case "nl-BE" :
        return "NL_BE";
    case "nl" :
    case "nl-NL" :
        return "Nl";
    case "nb" :
    case "nb-NO" :
    case "nn" :
    case "nn-NO" :
    case "no" :
        return "Nb";
    case "pl" :
    case "pl-PL" :
        return "Pl";
    case "pt" :
    case "pt-BR" :
    case "pt-PT" :
        return "Pt";
    case "ru" :
    case "ru-RU" :
        return "Ru";
    case "sk" :
    case "sk-SK" :
        return "Sk";
    case "sv" :
    case "sv-FI" :
    case "sv-SE" :
        return "Sv";
    case "tr" :
    case "tr-CY" :
    case "tr-TR" :
        return "Tr_CY";
    case "zh-Hant" :
        return "ZhHant";
    case "zh" :
    case "zh-CN" :
    case "zh-HK" :
    case "zh-Hans" :
    case "zh-MO" :
    case "zh-SG" :
    case "zh-TW" :
        return "Zh";
    default:
      return "En";
  }
}

function localeStringToLocaleName(locale) {
  switch (locale) {
    case "DE" :
        return "German";
    case "DA" :
    case "DA_DK" :
    case "DK" :
        return "Danish";
    case "EN" :
        return "English";
    case "ES" :
        return "Spanish";
    case "FI" :
        return "Finnish";
    case "FR" :
        return "French";
    case "EL" :
    case "EL_GR" :
    case "GR" :
        return "Greek";
    case "HR" :
        return "Croatian";
    case "IT" :
        return "Italian";
    case "JA" :
    case "JA_JP" :
    case "JP" :
        return "Japanese";
    case "ES_LA" :
    case "LA" :
        return "Spanish (Latin America)";
    case "NL" :
        return "Dutch";
    case "NO" :
        return "Norwegian";
    case "PL" :
        return "Polish";
    case "PT" :
        return "Portuguese";
    case "BR" :
    case "PT_BR" :
        return "Portuguese (Brazil)";
    case "RU" :
        return "Russian";
    case "SE" :
    case "SV" :
    case "SV_SE" :
        return "Swedish";
    case "CN" :
    case "ZH_CN" :
        return "Chinese (Simplified)";
    case "TW" :
    case "ZH" :
    case "ZH_TW" :
        return "Chinese (Traditional)";
    default:
      return locale;
  }
}

var defaultLocale = {
  locale: "en",
  localeDirection: "ltr",
  cardNumberLabel: "Card Number",
  cardDetailsLabel: "Card Details",
  inValidCardErrorText: "Card number is invalid.",
  inCompleteCVCErrorText: "Your card's security code is incomplete.",
  inValidCVCErrorText: "Your card's security code is invalid.",
  inCompleteExpiryErrorText: "Your card's expiration date is incomplete.",
  inValidExpiryErrorText: "Your card's expiration date is invalid.",
  pastExpiryErrorText: "Your card's expiration date is invalid",
  poweredBy: "Powered By Hyperswitch",
  validThruText: "Expiry",
  sortCodeText: "Sort Code",
  accountNumberText: "Account Number",
  cvcTextLabel: "CVC",
  emailLabel: "Email",
  emailInvalidText: "Invalid email address",
  emailEmptyText: "Email cannot be empty",
  line1Label: "Address line 1",
  line1Placeholder: "Street address",
  line1EmptyText: "Address line 1 cannot be empty",
  line2Label: "Address line 2",
  line2Placeholder: "Apt., unit number, etc (optional)",
  cityLabel: "City",
  cityEmptyText: "City cannot be empty",
  postalCodeLabel: "Postal Code",
  postalCodeEmptyText: "Postal code cannot be empty",
  stateLabel: "State",
  fullNameLabel: "Full name",
  fullNamePlaceholder: "First and last name",
  countryLabel: "Country",
  currencyLabel: "Currency",
  bankLabel: "Select Bank",
  redirectText: "After submitting your order, you will be redirected to securely complete your purchase.",
  bankDetailsText: "After submitting these details, you will get bank account information to make payment. Please make sure to take a note of it.",
  orPayUsing: "Or pay using",
  addNewCard: "Add credit/debit card",
  useExisitingSavedCards: "Use saved payment methods",
  saveCardDetails: "Save card details",
  addBankAccount: "Add bank account",
  payNowButton: "Pay Now",
  cardNumberEmptyText: "Card Number cannot be empty",
  cardExpiryDateEmptyText: "Card expiry date cannot be empty",
  cvcNumberEmptyText: "CVC Number cannot be empty",
  enterFieldsText: "Please enter all fields",
  enterValidDetailsText: "Please enter valid details",
  card: "Card",
  billingNameLabel: "Billing name",
  cardHolderName: "Card Holder Name",
  cardNickname: "Card Nickname",
  billingNamePlaceholder: "First and last name",
  firstName: "First name",
  lastName: "Last name",
  billingDetails: "Billing Details",
  requiredText: "Required",
  cardHolderNameRequiredText: "Card Holder's name required",
  invalidDigitsCardHolderNameError: "Card Holder's name cannot have digits",
  lastNameRequiredText: "Last Name Required",
  nickNameLengthExceedError: "Nickname cannot exceed 12 characters",
  invalidDigitsNickNameError: "Nickname cannot have more than 2 digits",
  cardExpiresText: "expires",
  addPaymentMethodLabel: "Add new payment method",
  walletDisclaimer: "Wallet details will be saved upon selection",
  deletePaymentMethod: "Delete",
  enterValidCardNumberErrorText: "Please enter a valid card number.",
  line2EmptyText: "Address line 2 cannot be empty.",
  postalCodeInvalidText: "Invalid postal code.",
  stateEmptyText: "State cannot be empty.",
  ibanEmptyText: "IBAN cannot be empty.",
  accountNumberInvalidText: "Enter a valid account number",
  phoneInvalidText: "Enter a valid phone number",
  blikCodeInvalidText: "Enter a valid 6-digit Blik code",
  selectPaymentMethodText: "Please select a payment method and try again.",
  achBankDebitTermsPart1: "Your ACH Debit Authorization will be set up now, but we'll confirm the amount and let you know before future payments are taken.",
  achBankDebitTermsPart2: "",
  sepaDebitTermsPart1: "By providing your payment information and confirming to this mandate form, you authorise (A) ",
  sepaDebitTermsPart2: ", the Creditor and/or our payment service provider(s) to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from ",
  sepaDebitTermsPart3: ". As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. Your rights are explained in a statement that you can obtain from your bank.",
  becsDebitTerms: "By providing your bank account details and confirming this payment, you agree to this Direct Debit Request and the Direct Debit Request service agreement and authorise Hyperswitch Payments Australia Pty Ltd ACN 160 180 343 Direct Debit User ID number 507156 (\"Hyperswitch\") to debit your account through the Bulk Electronic Clearing System (BECS) on behalf of Hyperswitch Payment Widget (the \"Merchant\") for any amounts separately communicated to you by the Merchant. You certify that you are either an account holder or an authorised signatory on the account listed above.",
  surchargeMsgAmountPart1: "A surcharge amount of ",
  surchargeMsgAmountPart2: " will be applied for this transaction.",
  surchargeMsgAmountForCardPart1: "A surcharge amount of up to ",
  surchargeMsgAmountForCardPart2: " will be applied for this transaction.",
  surchargeMsgAmountForOneClickWallets: "Additional fee applicable.",
  on: "on",
  and: "and",
  nameEmptyText: "Please provide your name.",
  completeNameEmptyText: "Please provide your complete name.",
  billingDetailsText: "Billing Details",
  socialSecurityNumberLabel: "Social Security Number",
  saveWalletDetails: "Wallet details will be saved upon selection.",
  morePaymentMethods: "More payment methods",
  useExistingPaymentMethods: "Use saved payment methods",
  nicknamePlaceholder: "Card Nickname (Optional)",
  cardExpiredText: "This card has expired.",
  cardHeader: "Card information",
  cardBrandConfiguredErrorText: " is not supported at the moment.",
  currencyNetwork: "Currency Networks",
  expiryPlaceholder: "MM / YY",
  dateOfBirth: "Date of Birth",
  vpaIdLabel: "Vpa Id",
  vpaIdEmptyText: "Vpa Id cannot be empty.",
  vpaIdInvalidText: "Invalid Vpa Id address.",
  dateofBirthRequiredText: "Date of birth is required.",
  dateOfBirthInvalidText: "Age should be greater than or equal to 18 years.",
  dateOfBirthPlaceholderText: "Enter Date of Birth.",
  formFundsInfoText: "Funds will be credited to this account.",
  formFundsCreditInfoTextPart1: "Your funds will be credited in the selected ",
  formFundsCreditInfoTextPart2: ".",
  formEditText: "Edit",
  formSaveText: "Save",
  formSubmitText: "Submit",
  formSubmittingText: "Submitting",
  formSubheaderBillingDetailsText: "Enter your billing address.",
  formSubheaderCardText: "Your card details.",
  formSubheaderAccountTextPart1: "Your account.",
  formSubheaderAccountTextPart2: "",
  formHeaderReviewText: "Review",
  formHeaderReviewTabLayoutTextPart1: "Review your ",
  formHeaderReviewTabLayoutTextPart2: " details.",
  formHeaderBankTextPart1: "Enter ",
  formHeaderBankTextPart2: " bank details.",
  formHeaderWalletTextPart1: "Enter ",
  formHeaderWalletTextPart2: " wallet details.",
  formHeaderEnterCardText: "Enter card details.",
  formHeaderSelectBankText: "Select a bank method.",
  formHeaderSelectWalletText: "Select a wallet.",
  formHeaderSelectAccountText: "Select an account for payouts.",
  formFieldACHRoutingNumberLabel: "Routing Number",
  formFieldSepaIbanLabel: "International Bank Account Number (IBAN)",
  formFieldSepaBicLabel: "Bank Identifier Code (Optional)",
  formFieldPixIdLabel: "Pix ID",
  formFieldBankAccountNumberLabel: "Bank Account Number",
  formFieldPhoneNumberLabel: "Phone Number",
  formFieldCountryCodeLabel: "Country Code (Optional)",
  formFieldBankNameLabel: "Bank Name (Optional)",
  formFieldBankCityLabel: "Bank City (Optional)",
  formFieldCardHoldernamePlaceholder: "Your Name",
  formFieldBankNamePlaceholder: "Bank Name",
  formFieldBankCityPlaceholder: "Bank City",
  formFieldEmailPlaceholder: "Your Email",
  formFieldPhoneNumberPlaceholder: "Your Phone",
  formFieldInvalidRoutingNumber: "Routing number is invalid.",
  infoCardRefId: "Ref Id",
  infoCardErrCode: "Error Code",
  infoCardErrMsg: "Error Message",
  infoCardErrReason: "Reason",
  linkRedirectionTextPart1: "Redirecting in ",
  linkRedirectionTextPart2: " seconds ...",
  linkExpiryInfoPart1: "Link expires on: ",
  linkExpiryInfoPart2: "",
  payoutFromTextPart1: "Payout from ",
  payoutFromTextPart2: "",
  payoutStatusFailedMessage: "Failed to process your payout. Please check with your provider for more details.",
  payoutStatusPendingMessage: "Your payout should be processed within 2-3 business days.",
  payoutStatusSuccessMessage: "Your payout was successful. Funds were deposited in your selected payment mode.",
  payoutStatusFailedText: "Payout Failed",
  payoutStatusPendingText: "Payout Processing",
  payoutStatusSuccessText: "Payout Successful",
  pixCNPJInvalidText: "Invalid Pix CNPJ.",
  pixCNPJEmptyText: "Pix CNPJ cannot be empty.",
  pixCNPJLabel: "Pix CNPJ",
  pixCNPJPlaceholder: "Enter Pix CNPJ.",
  pixCPFInvalidText: "Invalid Pix CPF.",
  pixCPFEmptyText: "Pix CPF cannot be empty.",
  pixCPFLabel: "Pix CPF",
  pixCPFPlaceholder: "Enter Pix CPF.",
  pixKeyEmptyText: "Pix key cannot be empty.",
  pixKeyPlaceholder: "Enter Pix key.",
  pixKeyLabel: "Pix key.",
  invalidCardHolderNameError: "Card Holder's name cannot have digits.",
  invalidNickNameError: "Nickname cannot have more than 2 digits.",
  cardTermsPart1: "By providing your card information, you allow ",
  cardTermsPart2: " to charge your card for future payments in accordance with their terms.",
  useExisitingSavedCardsWeb: "Use saved debit/credit cards.",
  unsupportedCardErrorText: "Card brand is not supported.",
  selectCardBrand: "Select a card brand",
  enterValidDigitsText: "Please enter valid",
  digitsText: " digits",
  enterValidIban: "Please enter a valid Iban",
  mandatoryFieldText: "This field is mandatory",
  disclaimerTextAchTransfer: "Please make note of these details. You will not be able to generate this details again.",
  instructionalTextOfAchTransfer: "Use the below details to transfer amount",
  accountDetailsText: "Account details",
  achBankTransferText: "ACH Bank Transfer",
  bankName: "Bank name",
  swiftCode: "Swift code",
  doneText: "Done",
  copyToClipboard: "Copy to clipboard",
  cardNotEligibleText: "This card is not accepted for this payment.",
  accountHolderNameLabel: "Account Holder Name",
  accountHolderNamePlaceholder: "Account Holder Name",
  accountNumberPlaceholder: "Account Number",
  bankIdentifierPlaceholder: "Bank Identifier",
  bankIssuerPlaceholder: "Select Bank Issuer",
  bankTypeLabel: "Bank Type",
  bankTypePlaceholder: "Select Bank Type",
  blikCodeLabel: "BLIK Code",
  blikCodePlaceholder: "BLIK Code",
  branchCodeLabel: "Branch Code",
  branchCodePlaceholder: "Branch Code",
  bsbNumberPlaceholder: "BSB Number",
  cardNetworkLabel: "Card Network",
  cardNetworkPlaceholder: "Select Card Network",
  cardNumberPlaceholder: "1234 1234 1234 1234",
  cityPlaceholder: "City",
  clientUidLabel: "Client UID",
  clientUidPlaceholder: "Client UID",
  countryPlaceholder: "Select Country",
  cryptoNetworkLabel: "Network",
  cryptoNetworkPlaceholder: "Network",
  currencyPlaceholder: "Select Currency",
  cvcPlaceholder: "123",
  descriptionLabel: "Description",
  descriptionPlaceholder: "Description",
  dialingCodePlaceholder: "Select Dialing Code",
  documentNumberLabel: "Document Number",
  documentNumberPlaceholder: "Document Number",
  documentTypeLabel: "Document Type",
  documentTypePlaceholder: "Select Document Type",
  expiryMonthLabel: "Expiry Month",
  expiryMonthPlaceholder: "Select Month",
  expiryYearLabel: "Expiry Year",
  expiryYearPlaceholder: "Select Year",
  firstNamePlaceholder: "First Name",
  giftCardCvcPlaceholder: "CVC",
  giftCardNumberPlaceholder: "Card Number",
  ibanPlaceholder: "IBAN",
  languagePreferenceLabel: "Language Preference",
  languagePreferencePlaceholder: "Select Language",
  lastNamePlaceholder: "Last Name",
  postalCodePlaceholder: "Postal Code",
  productNameLabel: "Product Name",
  productNamePlaceholder: "Product Name",
  routingNumberPlaceholder: "Routing Number",
  sortCodePlaceholder: "Sort Code",
  sourceBankAccountIdLabel: "Source Bank Account ID",
  sourceBankAccountIdPlaceholder: "Source Bank Account ID",
  statePlaceholder: "Select State",
  upiIdPlaceholder: "UPI ID",
  loadingText: "Loading...",
  completeButtonText: "Complete",
  processingText: "Processing...",
  processingRequestText: "Processing Your Request",
  processingRequestSubtext: "Please do not press back or close this screen"
};

export {
  localeTypeToString ,
  localeStringToType ,
  localeStringToLocaleName ,
  defaultLocale ,
}
/* No side effect */
